'use client';

import Script from 'next/script';
import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect, Suspense } from 'react';

// --- 1. KOMPONENT WEWNĘTRZNY (Używa hooków) ---
// Wydzielamy logikę, która wymaga dostępu do parametrów URL
function AnalyticsLogic() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    // Ta logika uruchamia się przy zmianie ścieżki lub parametrów
    // Obecnie GA4 Enhanced Measurement robi to automatycznie,
    // ale zostawiamy ten hook, jeśli chciałbyś dodać custom events w przyszłości.
    const url = pathname + searchParams.toString();
  }, [pathname, searchParams]);

  return null; // Ten komponent nic nie renderuje wizualnie
}

// --- 2. KOMPONENT GŁÓWNY (Bezpieczny) ---
// Ładuje skrypty i owija logikę w Suspense
export default function GoogleAnalytics({ GA_MEASUREMENT_ID }: { GA_MEASUREMENT_ID: string }) {
  return (
    <>
      {/* Skrypty ładujemy normalnie (nie potrzebują Suspense) */}
      <Script
        strategy="afterInteractive"
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}
      />
      <Script
        id="google-analytics"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());

            // DOMYŚLNA KONFIGURACJA: ODMOWA (Privacy First)
            gtag('consent', 'default', {
              'analytics_storage': 'denied',
              'ad_storage': 'denied',
              'ad_user_data': 'denied',
              'ad_personalization': 'denied'
            });

            gtag('config', '${GA_MEASUREMENT_ID}', {
              page_path: window.location.pathname,
            });
          `,
        }}
      />

      {/* Logikę używającą useSearchParams owijamy w barierę ochronną */}
      <Suspense fallback={null}>
        <AnalyticsLogic />
      </Suspense>
    </>
  );
}